import { memo } from 'react'
import { useField, useFormikContext } from 'formik'

import { Menu, MenuItem } from '@mui/material'
import { KeyboardArrowDown, SaveAsOutlined, SaveOutlined } from '@mui/icons-material'

import { Button, ButtonGroup, usePopoverState } from '@collaborate-health/uikit'

import { ArticlePublicationStatus } from '../../enums'

export interface ArticleSaveButtonProps {
  name: string
}

const ArticleSaveButton: React.FC<ArticleSaveButtonProps> = ({ name }) => {
  const [{ value }, , { setValue }] = useField<ArticlePublicationStatus>(name)
  const { dirty, isSubmitting, isValid } = useFormikContext()

  const [anchorRef, open, onOpen, onClose] = usePopoverState<HTMLButtonElement>()

  const disabled = isSubmitting || !isValid || !dirty

  return (
    <>
      <ButtonGroup disabled={disabled} size='small' color='primary'>
        <Button
          startIcon={value === ArticlePublicationStatus.Draft ? <SaveAsOutlined /> : <SaveOutlined />}
          size='small'
          variant='contained'
          type='submit'
        >
          {value === ArticlePublicationStatus.Draft ? 'Save as draft' : 'Save and publish'}
        </Button>
        <Button ref={anchorRef} size='small' variant='contained' onClick={onOpen}>
          <KeyboardArrowDown />
        </Button>
      </ButtonGroup>
      <Menu
        anchorEl={anchorRef.current}
        open={open}
        onClose={onClose}
        onClick={onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          selected={value === ArticlePublicationStatus.Draft}
          onClick={() => {
            setValue(ArticlePublicationStatus.Draft)
          }}
        >
          Save as draft
        </MenuItem>
        <MenuItem
          selected={value === ArticlePublicationStatus.Published}
          onClick={() => {
            setValue(ArticlePublicationStatus.Published)
          }}
        >
          Save and publish
        </MenuItem>
      </Menu>
    </>
  )
}

export default memo(ArticleSaveButton)

